<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <customer-search-box
          :label="customLabel.qu_date || '客户名称'"
          slot="qu_custname"
          placeholder="请输入或选择客户名称"
          v-model="form.main.qu_custname"
          @onchange="custChange"
          @select="onSelectCustomer"
        />
        <date-field
          :label="customLabel.qu_date || '发布日期'"
          v-model="form.main.qu_date"
          slot="qu_date"
        />
        <date-field
          :label="customLabel.qu_enddate || '截止日期'"
          v-model="form.main.qu_enddate"
          slot="qu_enddate"
        />
        <div
          class="weui-cell weui-cell_select weui-cell_select-after"
          slot="qu_contact"
        >
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.qu_contact || "联系人"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.main.qu_contact"
              placeholder="请选择"
            >
              <option v-for="(items, index) in contactsList" :key="index">
                {{ items.value }}
              </option>
            </select>
          </div>
        </div>
        <div class="weui-cell" slot="qu_tel">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.qu_tel || "联系电话"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.qu_tel"
              placeholder="请输入联系电话"
            />
          </div>
        </div>
        <employee-field slot="qu_seller" 
        :label="customLabel.qu_seller || '业务员'"
         v-model="form.main.qu_seller"
          @select="onSelectEmployee" />
        <payment-field
          :label="customLabel.qu_payments"
          v-model="form.main.qu_payments"
          @select="onSelectPayment"
          slot="qu_payments"
          limit="customer"
          :limit-id="form.main.qu_custid"
        />
        <currency-field
          slot="qu_currency"
          :label="customLabel.qu_currency"
          v-model="form.main.qu_currency"
          @select="onSelectCurrency"
        />
        <div class="weui-cell" slot="qu_taxrate">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.qu_taxrate || "税率"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.qu_taxrate"
              placeholder="请输入税率"
            />
          </div>
        </div>
      </custom-layout>
      <div
        class="weui-cells__group"
        v-for="(item, xindex) in form.items"
        :key="'1-' + xindex"
      >
        <div class="weui-cells__title">
          <span>产品{{ xindex + 1 }}</span>
          <a
            href="javascript:;"
            class="header-tool"
            @click="removeItem(xindex)"
          >
            <span>删除</span>
          </a>
        </div>
        <custom-layout
          class="weui-cells"
          :view-config="customViewConfig"
          position="detail1"
        >
          <div class="weui-cell" slot="qd_custprodcode">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.qd_custprodcode || "客户物料编号"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <span>{{ item.qd_custprodcode }}</span>
            </div>
          </div>
          <div class="weui-cell" slot="qd_prodcode">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.qd_prodcode || "产品编号"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <span>{{ item.qd_prodcode }}</span>
            </div>
          </div>
          <product-field slot="qd_prodName" :label="customLabel.qd_prodName || '产品名称'"
            v-model="item.qd_prodName"
            @select="onSelectProduct($event, xindex)"
          />
          <div class="weui-cell" slot="qd_prodSpec">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.qd_prodSpec || "规格"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="item.qd_prodSpec"
                placeholder="请填写"
              />
            </div>
          </div>
          <div class="weui-cell" slot="qd_prodOriSpec">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.qd_prodOriSpec || "型号"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="item.qd_prodOriSpec"
                placeholder="请填写"
              />
            </div>
          </div>
          <div class="weui-cell" slot="qd_qty">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.qd_qty || "数量"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                placeholder="请填写"
                v-model="item.qd_qty"
                minvalue="0"
                maxvalue="99999999"
              />
            </div>
          </div>
          <div class="weui-cell" slot="qd_prodUnit">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.qd_prodUnit || "单位"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="item.qd_prodUnit"
                placeholder="请填写"
              />
            </div>
          </div>
          <div class="weui-cell" slot="qd_zxbzs">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.qd_zxbzs || "最小包装量"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                placeholder="请填写"
                minvalue="0"
                maxvalue="99999999"
                v-model="item.qd_zxbzs"
              />
            </div>
          </div>
          <div class="weui-cell" slot="qd_zxdgs">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.qd_zxdgs || "最小订购量"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                placeholder="请填写"
                minvalue="0"
                maxvalue="99999999"
                v-model="item.qd_zxdgs"
              />
            </div>
          </div>
          <div
            class="weui-cell weui-cell_access"
            slot="showData"
            @click="() => (pindex = xindex)"
          >
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.showData || "单价"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                :value="getPriceDesc(item)"
                placeholder="请填写"
                disabled
              />
            </div>
            <div class="weui-cell__ft"></div>
          </div>
          <div class="weui-cell" slot="qd_deliveryday">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.qd_deliveryday || "交期天数"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                placeholder="请填写"
                v-model="item.qd_deliveryday"
                minvalue="0"
                maxvalue="99999999"
              />
            </div>
          </div>
          <date-field
            :label="customLabel.qd_delivery || '需求日期'"
            v-model="item.qd_delivery"
            slot="qd_delivery"
          />
          <div class="weui-cell" slot="qd_prodBrand">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.qd_prodBrand || "厂家/品牌"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="item.qd_prodBrand"
                placeholder="请填写"
              />
            </div>
          </div>
          <div class="weui-cell" slot="qd_remark">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.qd_remark || "备注"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="item.qd_remark"
                placeholder="请填写"
              />
            </div>
          </div>
          <a
            href="javascript:"
            v-if="xindex == form.items.length - 1"
            class="weui-cell weui-cell_link"
            @click="addItem"
          >
            <div class="weui-cell__bd">添加更多</div>
          </a>
        </custom-layout>
      </div>
      <div class="weui-cells">
        <file-field v-model="form.main.qu_attach" ref="qu_attach" />
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
    <div class="mark" v-if="pindex != -1">
      <div class="page page__has-bar">
        <div class="page__bd">
          <div
            class="weui-cells__group"
            v-for="(item, gindex) in form.items[pindex].gradientPriceDTOList"
            :key="gindex"
          >
            <div class="weui-cells__title">
              <span>阶梯报价{{ gindex + 1 }}</span>
              <a
                href="javascript:;"
                class="header-tool"
                @click="removeMoneyItem(gindex)"
              >
                <span>删除</span>
              </a>
            </div>
            <div class="weui-cells">
              <div class="weui-cell">
                <div class="weui-cell__hd">
                  <label for class="weui-label">数量 </label>
                </div>
                <div class="weui-cell__bd">
                  <input
                    class="weui-input"
                    type="number"
                    v-model="item.gp_step"
                    placeholder="请填写"
                  />
                </div>
              </div>
              <div class="weui-cell">
                <div class="weui-cell__hd">
                  <label for class="weui-label">单价</label>
                </div>
                <div class="weui-cell__bd">
                  <input
                    class="weui-input"
                    type="number"
                    v-model="item.gp_price"
                    @change="changeMoneyItem(item)"
                    placeholder="请填写"
                  />
                </div>
              </div>
            </div>
          </div>
          <a
            href="javascript:"
            class="weui-cell weui-cell_link"
            @click="addMoneyItem"
          >
            <div class="weui-cell__bd">添加更多</div>
          </a>
        </div>
        <div class="footer-bar weui-dialog__ft">
          <a
            href="javascript:;"
            class="weui-dialog__btn weui-dialog__btn_primary"
            @click="() => (pindex = -1)"
            >确定</a
          >
          <!-- <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_default" @click="() => pindex = -1">取消</a> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import DateField from "@/components/field/DateField.vue";
import FileField from "@/components/field/FileField.vue";
import CurrencyField from "@/components/field/CurrencyField.vue";
import CustomerSearchBox from "@/components/field/CustomerSearchBox.vue";
import EmployeeField from "@/components/field/EmployeeField.vue";
import ProductField from "@/components/field/ProductField.vue";
import PaymentField from "@/components/field/PaymentField.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    CustomLayout,
    DateField,
    FileField,
    CurrencyField,
    CustomerSearchBox,
    EmployeeField,
    ProductField,
    PaymentField
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/sale/quotation",
      codeField: "qu_code",
      statusField: "qu_statuscode",
      caller: "Quotation",
      xtype: "sale-quotation-formpanel",
      pindex: -1,
      form: {
        main: {
          qu_date: this.dateFormat(new Date(), "yyyy-MM-dd hh:mm:ss"),
          qu_enddate: this.dateFormat(new Date(), "yyyy-MM-dd hh:mm:ss"),
          qu_taxrate: 13
        },
        items: [
          {
            qd_prodcode: null,
            qd_prodName: null,
            qd_prodOriSpec: null,
            qd_qty: 0,
            qd_prodUnit: null,
            qd_zxbzs: 0,
            qd_zxdgs: 0,
            qd_delivery: this.dateFormat(new Date(), "yyyy-MM-dd hh:mm:ss"),
            qd_prodBrand: null,
            qd_prodSpec: null,
            gradientPriceDTOList: [],
          },
        ],
      },
      contactsList: [],
    };
  },
  mounted() {
    var me = this;
    if (!me.$route.query.id) {
      me.$loading({
        url: "/api/commons/number/getMaxnumber",
        method: "POST",
        params: {
          caller: "Quotation",
        },
      }).then(function (res) {
        if (res.success) {
          me.form.main.qu_code = res.data;
        }
      });
    }
  },
  methods: {
    onSelectEmployee(selection) {
      var me = this,
        main = me.form.main;
      main.qu_sellerid = selection.id;
      main.qu_sellercode = selection.em_code;
    },
    /**
     * 选择客户
     */
    onSelectCustomer(selection) {
      var me = this,
        main = me.form.main;
      main.qu_custname = selection.cu_name;
      main.qu_custid = selection.id;
      main.qu_custcode = selection.cu_code;
      main.qu_paymentsid = selection.cu_paymentsid;
      main.qu_paymentscode = selection.cu_paymentscode;
      main.qu_payments = selection.cu_payments;
      main.qu_currency = selection.cu_currency;
      main.qu_contact = selection.cc_name;
      main.qu_tel = selection.cc_tel;
      main.qu_sellercode = selection.cu_sellercode;
      main.qu_seller = selection.cu_sellername;
      main.qu_sellerid = selection.cu_sellerid;
      main.qu_taxrate = selection.cu_taxrate;
      me.getContactsList(selection.id);
    },
    onSelectProduct(selection, key) {
      var me = this,
        items = me.form.items;
      items[key].pd_prodid = selection.id;
      items[key].qd_prodcode = selection.pr_code;
      items[key].qd_prodName = selection.pr_detail;
      items[key].qd_zxbzs = selection.pr_zxbzs;
      items[key].qd_zxdgs = selection.pr_moq;
      items[key].qd_prodOriSpec = selection.pr_orispeccode;
      items[key].qd_prodUnit = selection.pr_unit;
      items[key].qd_prodSpec = selection.pr_spec;
      items[key].qd_prodBrand = selection.pr_brand;
    },
    /**
     * 选择币种
     */
    onSelectCurrency(selection) {
      var me = this,
        main = me.form.main;
      main.qu_currency = selection.cr_name;
    },
    /**
     * 选择收款方式
     */
    onSelectPayment(selection) {
      var me = this,
        main = me.form.main;
      main.qu_paymentsid = selection.cp_paid;
      main.qu_paymentscode = selection.cp_pacode;
    },
    /* 
      获取联系人
    */
    getContactsList(id) {
      var me = this;
      me.$ajax({
        url: "/api/document/customer/getContactCombo/?id=" + id,
      }).then(function (res) {
        if (res.success) {
          me.contactsList = res.data;
        }
      });
    },
    /* 
      手动输入客户时置空id和code
    */
    custChange() {
      var me = this,
        main = me.form.main;
      main.qu_custid = null;
      main.qu_custcode = null;
    },

    /**
     * 删除行
     */
    removeItem(index) {
      var me = this,
        items = me.form.items;
      if (items.length == 1) {
        me.$weui.topTips("请至少保留一行", 2000);
      } else {
        items.splice(index, 1);
      }
    },
    /**
     * 新增行
     */
    addItem() {
      var me = this,
        items = me.form.items;
      items.push({
        qd_delivery: this.dateFormat(new Date(), "yyyy-MM-dd hh:mm:ss"),
      });
    },

    removeMoneyItem(gindex) {
      var me = this,
        list = me.form.items[me.pindex].gradientPriceDTOList;
      // if (list.length == 1) {
      //   me.$weui.topTips("请至少保留一行", 2000);
      // } else {
      list.splice(gindex, 1);
      // }
    },
    addMoneyItem() {
      var me = this;
      if (!me.form.items[me.pindex].gradientPriceDTOList) {
        me.form.items[me.pindex].gradientPriceDTOList = [];
      }
      me.form.items[me.pindex].gradientPriceDTOList.push({
        gp_price: 0,
        gp_step: 0,
        gp_netprice:0,
      });
    },
    changeMoneyItem(item){
      item.gp_netprice = item.gp_price
    },
    getPriceDesc(item) {
      var list = item.gradientPriceDTOList;
      if (list) {
        return list.map((i) => i.gp_step + " +     ¥" + i.gp_price).join(";");
      }
      return null;
    },
    save() {
      var me = this,
        main = me.form.main,
        items = me.form.items;
      if (!main.qu_enddate) {
        me.$weui.topTips("请选择截止日期", 2000);
      } else if (!main.qu_currency) {
        me.$weui.topTips("请选择币种", 2000);
      } else {
        var count = 0;
        items.forEach(function (item) {
          if (!item.qd_deliveryday) {
            me.$weui.topTips(`第${count + 1}行交期天数未填写`, 2000);
            return false;
          } else {
            count++;
            item.qd_detno = count;
          }
        });
      }
      if (count) {
        main.mr_qty = me.$number.round(main.mr_qty || 0, 3);
        main.mr_ng_qty = me.$number.round(main.mr_ng_qty || 0, 3);
        main.mr_ok_rate = me.$number.round(main.mr_ok_rate || 0, 2);
        me.p_save();
      }
    },
  },
};
</script>

<style scoped>
.mark {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  background: #fff;
  z-index: 500;
  overflow-y: scroll;
}
</style>